import * as React from 'react';
require('./style.css');

interface IProps {
	message?: string | JSX.Element;
	position?: string;
}

interface IState {
	displayTooltip: boolean;
}

class Tooltip extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			displayTooltip: false,
		};

		this.hideTooltip = this.hideTooltip.bind(this);
		this.showTooltip = this.showTooltip.bind(this);
	}

	private node: HTMLElement;

	public componentDidMount() {
		document.addEventListener('click', this.handleClickOutside, true);
	}

	public componentWillUnmount() {
		document.removeEventListener('click', this.handleClickOutside, true);
	}

	private handleClickOutside = (e) => {
		if (!this.node || !this.node.contains(e.target)) {
			this.hideTooltip();
		}
	};

	private hideTooltip() {
		this.setState({ displayTooltip: false });
	}
	private showTooltip(e) {
		e.preventDefault();
		this.setState({ displayTooltip: !this.state.displayTooltip });
	}

	public render() {
		const { position, message } = this.props;

		let tooltipStyle = null;

		switch (position) {
			case 'top':
				tooltipStyle = 'tooltipTop';
				break;

			case 'bottom':
				tooltipStyle = 'tooltipBottom';
				break;

			case 'right':
				tooltipStyle = 'tooltipRight';
				break;

			case 'left':
				tooltipStyle = 'tooltipLeft';
				break;

			default:
				break;
		}

		return (
			<span ref={(node) => (this.node = node)} className="tooltip d-flex align-items-center">
				{this.state.displayTooltip && (
					<div className={`tooltipBubble ${tooltipStyle === null ? 'tooltipTop' : tooltipStyle}`}>
						<div className="tooltipMessage">{message}</div>
					</div>
				)}
				<span
					className="tooltipTrigger"
					onClick={(e) => this.showTooltip(e)}
					onMouseEnter={this.showTooltip}
					onMouseLeave={this.hideTooltip}
				>
					{this.props.children}
				</span>
			</span>
		);
	}
}

export { Tooltip };
